<template>
	<div class = "recharge-card">
		<div class = "recharge-card-text-div">
			<div>账号：{{sAccount}}</div>
			<div>当前账户余额（元）</div>
			<div>{{sBalance}}</div>
			<div v-if = "sAmountExp">有效日期：{{sAmountExp}}</div>
		</div>
	</div>
</template>

<script scoped>
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'Card',
		computed: mapGetters(["sAccount","sBalance","sAmountExp"]),
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style>
	.recharge-card {
		width: 100%;
		height: 170px;
		padding: 30px 35px 0 35px;
		background-color: #36364c;
		
	}
	.recharge-card>div {
		width: 100%;
		height: 141px;
		box-shadow: 0px 4px 3px #c5c5c5;
		background-image: url(../../assets/index-card_green_bg.jpg);
		background-size: 100% 100%;
	}
	.recharge-card-text-div {
		padding-left: 78px;
		padding-top: 20px;
		color: #ffffff;
		font-weight: 500;
	}
	.recharge-card-text-div>div:nth-child(1){
		font-size: 15px;
		padding: 10px 0px;
	}
	
	.recharge-card-text-div>div:nth-child(2){
		font-size: 15px;
	}
	.recharge-card-text-div>div:nth-child(3){
		font-size: 24px;
	}
	.recharge-card-text-div>div:nth-child(4){
		color: #595959;
		font-size: 12px;
		text-align: right;
		padding-right: 5px;
	}
</style>
